import React from 'react';
import UserNotificationSettingsTable from './UserNotificationSettingsTable';
import useUpdateUserSettings from './useUpdateUserSettings';
import useIntegrationMap from '../../admin/useIntegrationMap';
import useAppSelector from '../../app/redux/useAppSelector';
import type { UserSettingsNotificationsInput } from '../../graphql/generated/graphql';
import SettingsContainerView from '../../settings/SettingsContainerView';

const UserNotificationSettings = () => {
  const [integrations] = useIntegrationMap();
  const identities = useAppSelector(
    (state) => state.session.user.identities ?? [],
  );

  const updateUserSettings = useUpdateUserSettings();
  const isSlackIntegrated = !!integrations.slack;
  const hasSlackIdentity = !!identities.find((i) => i.platform === 'slack');
  const slackConnectUrl = `/settings/identity/connect/slack?redirect_url=${document.location.href}`;

  const handleChange = (
    scope: keyof UserSettingsNotificationsInput,
    platform: string,
    checked: boolean,
  ) => {
    updateUserSettings({ notifications: { [scope]: { [platform]: checked } } });
  };

  return (
    <SettingsContainerView
      title="Notifications"
      subtitle={`Choose which notifications you’d like to receive via ${
        isSlackIntegrated ? 'email and in Slack' : 'email'
      }:`}
    >
      <UserNotificationSettingsTable
        onChange={handleChange}
        slackConnectUrl={hasSlackIdentity ? null : slackConnectUrl}
        slackIntegrated={isSlackIntegrated}
      />
    </SettingsContainerView>
  );
};

export default UserNotificationSettings;
